export enum PRODUCT {
  // product of unlock calibration
  UNLOCK_PERISCOPE_CALIBRATION_ALL_SOURCES = 'recalibrate_summary_v_1_0',
  // product of unlock protocols
  UNLOCK_PROTOCOL_ALL_HEALTH = `unlock_protocol_all_health`,
  UNLOCK_PROTOCOL_ANTI_INFLAMMATION = `unlock_protocol_anti_inflammation`,
  UNLOCK_PROTOCOL_BLOOD_PRESSURE_MANAGEMENT = `unlock_protocol_blood_pressure_management`,
  UNLOCK_PROTOCOL_DETOX_AND_CLEANSING = `unlock_protocol_detox_and_cleansing`,
  UNLOCK_PROTOCOL_ENERGY_AND_VITALITY = `unlock_protocol_energy_and_vitality`,
  UNLOCK_PROTOCOL_FOCUS_AND_PRODUCTIVITY = `unlock_protocol_focus_and_productivity`,
  UNLOCK_PROTOCOL_HYDRATION = `unlock_protocol_hydration`,
  UNLOCK_PROTOCOL_LONGEVITY = `unlock_protocol_longevity`,
  UNLOCK_PROTOCOL_POSTURE_IMPROVEMENT = `unlock_protocol_posture_improvement`,
  UNLOCK_PROTOCOL_SLEEP_ENHANCEMENT_SYSTEM = `unlock_protocol_sleep_enhancement_system`,
  UNLOCK_PROTOCOL_STRESS_REDUCTION = `unlock_protocol_stress_reduction`,

  // startof - AsaX Ai Assistant products
  PURCHASE_ASAX_ASSISTANT_360_DNA = 'dev_asax_assistant_360_dna',
  UNLOCK_ASAX_ASSISTANT_360_DNA = 'dev_asax_assistant_unlock_360_dna',
  SUBSCRIBE_ASAX_ASSISTANT_1_YEAR = 'dev_asax_assistant_1_year',
  SUBSCRIBE_ASAX_ASSISTANT_3_MONTHS = 'dev_asax_assistant_3_month'
  // endof - AsaX Ai Assistant products
}
